import { render, staticRenderFns } from "./switch_nav.vue?vue&type=template&id=280a894f&scoped=true&"
import script from "./switch_nav.vue?vue&type=script&lang=js&"
export * from "./switch_nav.vue?vue&type=script&lang=js&"
import style0 from "./switch_nav.vue?vue&type=style&index=0&id=280a894f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a894f",
  null
  
)

export default component.exports